import { ZmTransactionUser } from "../../../api/modules/KontaxApi";
import { formatZmUserStatus, ZmUserStatus } from "../../../types";
import { IZmUser, ZmFilterOptions } from "./types";

export function mapZmUsers(users: ZmTransactionUser[]): IZmUser[] {
  return users.map((user, index) => ({
    id: user.email || String(index),
    email: user.email,
    firstName: user.firstName ?? undefined,
    lastName: user.lastName ?? undefined,
    legalName: user.legalName,
    frequency: user.frequency,
    status: formatZmUserStatus(user.status) as ZmUserStatus,
  }));
}

export function toZmRequestParams(
  filterOptions: Pick<
    ZmFilterOptions,
    "dateFrom" | "dateTo" | "vatPaymentFrequency" | "email" | "status"
  >,
  page: number
) {
  return {
    dateFrom: filterOptions.dateFrom!,
    dateTo: filterOptions.dateTo!,
    frequency: filterOptions.vatPaymentFrequency || undefined,
    email: filterOptions.email || undefined,
    status: filterOptions.status || undefined,
    page,
  };
}
